import {
  Callout,
  Expander,
  Heading,
  HorizontalRule,
  Section,
} from '@piggybank/core';
import T from 'prop-types';
import React from 'react';
import { MarkdownTranslation } from './Markdown';
import { Optional, Translation, TranslationScope } from './context';
import { localizationKeyPath } from './utils';

export const DynamicFormSection = ({
  context: { inReview = false, keyPath },
  formValues,
  children = [],
  renderChildren,
}) => (
  <Section key={localizationKeyPath(keyPath).join('.')}>
    <TranslationScope path={localizationKeyPath(keyPath)}>
      <Optional>
        <Heading
          accentBar={!inReview}
          level={2}
          marginBottom={inReview ? 3 : 4}
        >
          <MarkdownTranslation formValues={formValues} path="heading" />
        </Heading>
      </Optional>
      <Optional>
        <MarkdownTranslation
          formValues={formValues}
          marginBottom={4}
          path="description"
        />
      </Optional>

      <Optional>
        <Translation path="expander">
          {({ heading }) => (
            <>
              <HorizontalRule />
              <Expander
                id={`${localizationKeyPath(keyPath).join('-')}-expander`}
                marginBottom={4}
                title={heading}
              >
                <MarkdownTranslation
                  formValues={formValues}
                  path="expander.content"
                />
              </Expander>
            </>
          )}
        </Translation>
      </Optional>
      <Optional>
        <Translation path="callout">
          {({ heading, type = 'information' }) => (
            <Callout type={type}>
              <Heading level={4} marginBottom={1}>
                {heading}
              </Heading>
              <MarkdownTranslation
                formValues={formValues}
                path="callout.content"
              />
            </Callout>
          )}
        </Translation>
      </Optional>
      {inReview && <HorizontalRule marginBottom={4} />}
      {children.map(({ context }, index) => (
        <React.Fragment key={`formSection-child-${index}`}>
          {renderChildren({ context, formValues })}
        </React.Fragment>
      ))}
    </TranslationScope>
  </Section>
);

const ContextType = T.shape({
  keyPath: T.object,
  schemaPath: T.arrayOf(T.oneOfType([T.string, T.number])),
  inReview: T.bool,
});

DynamicFormSection.propTypes = {
  context: ContextType,
  formValues: T.object,
  renderChildren: T.func,
  children: T.arrayOf(T.shape({ context: ContextType })),
};
